import {
  Button,
  CircularProgress,
  Paper,
  Skeleton,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import PageTitle from "../../../../components/pageTitle";
import {
  handleAllInvoice,
  resetAllSummeryData,
} from "../../../../redux/actoin";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";
import { UtcToMiladi } from "../../../../scripts/functions";
import StepType from "../create/step1";
import Step2 from "../create/step2";
import Step3 from "../create/step3";
import Details from "./details";

const EditI = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [data, setData] = useState({});
  const [allGroups, setAllGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const [loading, setLoading] = useState(false);
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const navigate = useNavigate();
  const [seleted, setSeleted] = useState([]);
  const dispatch = useDispatch();
  const [loadingSumbit, setLoadingSumbit] = useState(false);
  const [currencyOption, setCurrencyOption] = useState([]);
  const [render, setRender] = useState(1);
  const { id } = useParams();
  useEffect(() => {
    if (!id) return;
    setLoading(true);

    axiosInstance
      .get(
        API.int.getData +
          `?guidStateRecNo=${company?.guidRecNo}&guidRecNo=${id}`,
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        setData({
          ...res?.data?.data?.header,
          dInvoiceDate: new Date(
            new Date(res?.data?.data?.header?.dInvoiceDate).toUTCString()
          ),
        });
        var temp = [];
        res?.data?.data?.details?.map((item) => {
          temp.push({ ...item, prev: true });
        });
        setSeleted(temp);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });

    axiosInstance
      .get(API.info.group + `?guidStateRecNo=${company?.guidRecNo}`, {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Accept-Language": "fa-IR",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        },
      })
      .then((res) => {
        setAllGroups(res.data.data);
      })
      .catch((err) => {});
  }, [id, render]);
  const AllInvoice = useSelector((state) => state.AllInvoice);
  useEffect(() => {
    if (
      currencyOption.length === 0 &&
      data.chInvoicePatternCode === "CurrSale"
    ) {
      axiosInstance
        .get(API.public.currency + `?guidStateRecNo=${company?.guidRecNo}`, {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        })
        .then((res) => {
          setCurrencyOption(res?.data?.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [data]);
  const handleSumbit = () => {
    setLoadingSumbit(true);
    var temp = [];
    seleted.map((item) => {
      if (
        data.chInvoicePatternCode === "CurrSale"
          ? item.flCurrencyAmount > 0
          : item.flAmount > 0
      ) {
        if (data.chInvoicePatternCode === "CurrSale") {
          temp.push({
            guidSellerStuffRecNo: item?.prev
              ? item?.guidSellerStuffRecNo
              : item?.guidRecNo,
            guidRecNo: item?.prev ? item?.guidRecNo : null,

            chSellerStuffSendName: item?.chSellerStuffSendName,
            guidCurrencyTypeRecNo: item?.guidCurrencyTypeRecNo
              ? item?.guidCurrencyTypeRecNo
              : localStorage.getItem("guidCurrencyTypeRecNo")
              ? localStorage.getItem("guidCurrencyTypeRecNo")
              : data.guidCurrencyTypeRecNo,
            moCurrencyExchangePrice: item?.moCurrencyExchangePrice,
            moCurrencyWage: item?.moCurrencyWage,
            moDiscount: item?.moDiscount || 0,
            flValueAddedPercent: item?.flValueAddedPercent || 0,
            flAmount: null,
            flCurrencyAmount: item?.flCurrencyAmount,
          });
        } else if (data.chInvoicePatternCode === "Jewelry") {
          temp.push({
            guidSellerStuffRecNo: item?.prev
              ? item?.guidSellerStuffRecNo
              : item?.guidRecNo,
            chSellerStuffSendName: item?.chSellerStuffSendName,
            flAmount: item?.flAmount,
            moUnitPrice: item?.moUnitPrice,
            moDiscount: item?.moDiscount || 0,
            flValueAddedPercent: Number(item?.flValueAddedPercent) || 0,
            moConstructionPrice: Number(item?.moConstructionPrice) || 0,
            moProfitPrice: Number(item?.moProfitPrice) || 0,
            moWorkPrice: Number(item?.moWorkPrice) || 0,
            guidRecNo: item?.prev ? item?.guidRecNo : null,
          });
        } else {
          temp.push({
            guidRecNo: item?.prev ? item?.guidRecNo : null,

            guidSellerStuffRecNo: item?.prev
              ? item?.guidSellerStuffRecNo
              : item?.guidRecNo,
            chSellerStuffSendName: item?.chSellerStuffSendName,
            flAmount: item?.flAmount,
            moUnitPrice: item?.moUnitPrice,
            moDiscount: item?.moDiscount || 0,
            flValueAddedPercent: item?.flValueAddedPercent || 0,
          });
        }
      }
    });
    var headers = {
      chSaleSoftID: data?.chSaleSoftID,
      chInvoiceTypeCode: data?.chInvoiceTypeCode,
      dInvoiceDate: UtcToMiladi(data?.dInvoiceDate),
      chInvoicePatternCode: data?.chInvoicePatternCode,
      guidBuyerRecNo: data?.guidBuyerRecNo,
      chSettlementMethodCode: data?.chSettlementMethodCode,
      guidStateRecNo: company?.guidRecNo,
      guidRecNo: id,
    };
    if (company?.chBusinessTypeCode === "Restaurant") {
      headers = {
        ...headers,
        intReceiptNumber: data.intReceiptNumber,
        chTableNumber: data.chTableNumber,
        tintPeopleCount: data.tintPeopleCount,
      };
    }
    axiosInstance
      .put(
        API.int.app,
        {
          header: headers,
          details: temp,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (res?.data?.isSuccess) {
          dispatch(resetAllSummeryData());
          if (AllInvoice.invoices?.page) {
            axiosInstance
              .get(
                API.int.item +
                  `?guidStateRecNo=${company?.guidRecNo}&guidRecNo=${res?.data.data}`,
                {
                  headers: {
                    Authorization: `Bearer ${userInfo?.token}`,
                    "Cache-Control": "no-cache",
                    Pragma: "no-cache",
                    Expires: "0",
                    "Accept-Language": "fa-IR",
                    chHostName: process.env.REACT_APP_CHHOSTNAME,
                  },
                }
              )
              .then((res) => {
                var temp = [...AllInvoice.invoices?.invoices];
                var index = temp.findIndex(
                  (it) => it.guidRecNo === data.guidRecNo
                );
                if (index !== -1) {
                  temp[index] = res.data.data;
                  dispatch(
                    handleAllInvoice({
                      ...AllInvoice.invoices,
                      invoices: temp,
                    })
                  );
                }

                navigate("/sell/invoice");

                toast.success(res?.data?.message);
              })
              .catch((err) => {
                toast.error(res?.data?.message);
              });
          } else {
            navigate("/sell/invoice");
            toast.success(res?.data?.message);
          }
        } else {
          toast.error(res?.data?.message);
        }
        setLoadingSumbit(false);
      })
      .catch((err) => {
        toast.error("خطایی رخ داده است مجدد تلاش کنید");
        setLoadingSumbit(false);
        /*      if (err.response.status === 401 || err.response.status === 403) {
            dispatch(handleLogOut());
          } */
      });
  };
  return (
    <>
      {" "}
      <PageTitle
        broadCrumb={[
          {
            title: "فروش",
            path: "/sell",
          },
          {
            title: "صورت حساب ",
            path: "/sell/invoice",
          },
        ]}
        title={"ویرایش صورت حساب "}
      />{" "}
      <Stepper
        activeStep={currentStep - 1}
        alternativeLabel
        className="relative z-40"
        sx={{
          direction: "ltr",
          py: 3,
          width: "100%",
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? "#fff"
              : theme.palette.background.paper,
        }}
      >
        {[`اطلاعات  `, `نوع  `, `خریدار `, ` اقلام`].map((label, index) => (
          <Step
            className="cursor-pointer"
            onClick={() => setCurrentStep(index + 1)}
            key={label}
          >
            <StepLabel
              sx={{
                ".MuiStepLabel-label": {
                  fontSize: {
                    md: "0.9rem !important",
                    xs: "1rem !important",
                  },
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>{" "}
      {loading ? (
        <Paper
          sx={{ zIndex: 9, position: "relative" }}
          className="mx-3 my-5 border py-3 px-3 relative z-50"
          elevation={1}
        >
          {" "}
          <div className="flex flex-col gap-4">
            <Skeleton
              height={"4rem"}
              width="100%"
              variant="rounded"
              animation="wave"
            />
            <Skeleton
              height={"4rem"}
              width="100%"
              variant="rounded"
              animation="wave"
            />
            <Skeleton
              height={"4rem"}
              width="100%"
              variant="rounded"
              animation="wave"
            />
            <Skeleton
              height={"4rem"}
              width="100%"
              variant="rounded"
              animation="wave"
            />
          </div>
        </Paper>
      ) : (
        <div className="relative z-50 fillInput">
          {currentStep === 1 ? (
            <>
              <div className="flex mx-3 px-3 justify-between mt-6 mb-3 items-start">
                <Button
                  sx={{ width: "135px" }}
                  variant="contained"
                  onClick={() => {
                    setCurrentStep(2);
                  }}
                >
                  <>مرحله بعد</>
                </Button>{" "}
                <Button
                  sx={{ width: "135px" }}
                  onClick={() => navigate("/sell/invoice")}
                  variant="outlined"
                >
                  بازگشت
                </Button>
              </div>
              <Details data={data} reRender={() => setRender((r) => r + 1)} />
            </>
          ) : currentStep === 2 ? (
            <>
              {" "}
              <div className="flex mx-3 px-3 justify-between mt-6 mb-3 items-start">
                <Button
                  sx={{ width: "135px" }}
                  variant="contained"
                  disabled={
                    !data.chInvoiceTypeCode ||
                    !data.chInvoicePatternCode ||
                    !data.chSettlementMethodCode ||
                    !data.chSaleSoftID ||
                    !data.dInvoiceDate
                  }
                  onClick={() => {
                    setCurrentStep(3);
                  }}
                >
                  <>مرحله بعد</>
                </Button>{" "}
                <Button
                  sx={{ width: "135px" }}
                  /*    onClick={() => navigate("/sell/invoice")} */
                  onClick={() => setCurrentStep(1)}
                  variant="outlined"
                >
                  مرحله قبل
                </Button>
              </div>
              <Paper className="mx-3 my-5 border py-3 px-3" elevation={1}>
                {" "}
                <StepType data={data} setData={setData} />
              </Paper>
            </>
          ) : currentStep === 3 ? (
            <>
              {" "}
              <div className="flex mx-3 px-3 justify-between mt-6 mb-3 items-start">
                <Button
                  sx={{ width: "135px" }}
                  variant="contained"
                  onClick={() => setCurrentStep(4)}
                  disabled={
                    data.chInvoiceTypeCode === "Type2"
                      ? false
                      : !data?.guidBuyerRecNo
                  }
                >
                  <>مرحله بعد</>
                </Button>{" "}
                <Button
                  sx={{ width: "135px" }}
                  onClick={() => setCurrentStep(2)}
                  variant="outlined"
                >
                  مرحله قبل
                </Button>
              </div>
              <Paper className="mx-3 my-5 border py-3 px-3" elevation={1}>
                {" "}
                <Step2
                  dataS={data}
                  setDataS={(e) => {
                    setData(e);
                    setCurrentStep(4);
                  }}
                />
              </Paper>{" "}
            </>
          ) : (
            <>
              <div className="flex mx-3 px-3 justify-between mt-6 mb-3 items-start">
                <Button
                  sx={{ width: "135px" }}
                  variant="contained"
                  onClick={handleSumbit}
                  disabled={seleted.length === 0 || loadingSumbit}
                >
                  {loadingSumbit ? <CircularProgress size={27} /> : <>ثبت</>}
                </Button>{" "}
                <Button
                  sx={{ width: "135px" }}
                  onClick={() => {
                    setCurrentStep(3);
                  }}
                  variant="outlined"
                >
                  مرحله قبل
                </Button>
              </div>
              <Paper className="mx-3 my-5 border py-3 px-3" elevation={1}>
                {" "}
                <Step3
                  seleted={seleted}
                  setSeleted={setSeleted}
                  dataS={data}
                  setDataS={setData}
                  currencyOption={currencyOption}
                  allGroups={allGroups}
                  setSelectedGroup={setSelectedGroup}
                  selectedGroup={selectedGroup}
                />
              </Paper>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default EditI;
